import { useEffect, useState } from "react";
import { login } from "../../features/authSlice.js";
import "./Login.css";
import QRcode from "../../assets/img/QR_code.svg";
import ArrowRight from "../../assets/icons/ArrowRight.svg";
import eyeInactive from "../../assets/icons/eye-inactive.svg";
import eyeActive from "../../assets/icons/eye-active.svg";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import ApiService from "../../components/Api_services";
import { useDispatch } from "react-redux";
import MultiPurpose from "../../components/multipurpose/MultiPurpose.js";
import FallbackImg from "../../components/FallbackImg";
import bgImg from "../../assets/img/bg-img.png";
import { logout } from "../../features/authSlice.js";

const Login = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isExist, setIsExist] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [showFirsTimeUser, setShowFirstTimeUser] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pid } = useParams();
  const location = useLocation();
  const [loginBackground, setLoginBackground] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [emailStatusFlag, setEmailStatusFlag] = useState("");
  const [showNotAvailablePopup, setShowNotAvailablePopup] = useState(false);

  // session_key SSO login via query param ?session_key=...
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const session_key = params.get("session_key");
    if (!session_key) return;
    const doSessionLogin = async () => {
      try {
        dispatch(logout()); // Clear any existing session before SSO login
        const data = await ApiService.login({ session_key });
        if (data && data.data?.access_token) {
          // Clear everything before storing fresh data except hidePromoMemo keys
          Object.keys(localStorage)
            .filter(key => !key.startsWith("hidePromoMemo"))
            .forEach(key => localStorage.removeItem(key));

          localStorage.setItem("access_token", data.data.access_token);
          // save session_key as well
          if (data.data.session_key) {
            localStorage.setItem("sso_session_key", data.data.session_key);
          } else {
            localStorage.setItem("sso_session_key", session_key);
          }
          // save salesman_id if returned
          const sid = data.data.salesman_id ?? data.data.salesman_ID;
          localStorage.setItem("salesman_id", sid);
          localStorage.setItem("real_company_name", data.data.real_name || "");
          dispatch(
            login({
              user: {
                name: data.data.user_name,
                email: data.data.user_email,
                profile_photo_url: data.data.profile_photo_url,
                is_subuser: data.data.is_subuser || false,
                subuser_id: data.data.subuser_id || "",
                sub_branch: data.data.sub_branch || null,
                main_id: data.data.main_id || null,
                salesman_id: data.data.salesman_id || null,
                company_name: data.data.company_name || "",
                has_cbd: data.data.has_cbd || false,
                has_term: data.data.has_term || false,
              },
              sub_role: data.data.sub_role || [],
            }),
          );
        } else {
          setLoginMessage("Session login failed.");
        }
      } catch (err) {
        setLoginMessage("Session login failed.");
      }
    };
    doSessionLogin();
  }, [location.search, dispatch]);

  const isLoggedIn = !!localStorage.getItem("access_token");

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/", { replace: true });
    }
  }, [isLoggedIn, navigate]);

  // const handleCompanyEmail = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const result = await ApiService.validateLoginEmail(email);
  //     if (result.status === true) {
  //       setIsExist(true);
  //     } else {
  //       setIsExist(false);
  //       setShowFirstTimeUser(true);
  //     }
  //   } catch (err) {
  //     setIsExist(false);
  //     setShowFirstTimeUser(true);
  //   }
  // };

  const handleCompanyEmail = async (e) => {
    e.preventDefault();
    try {
      const result = await ApiService.validateLoginEmail(email);
      if (result.status === true) {
        switch (result.flag) {
          case "active":
            setIsExist(true);
            setEmailStatusFlag("");
            setLoginMessage("");
            break;
          case "inactive":
          case "need_verify":
          case "approving":
            setIsExist(false);
            setShowFirstTimeUser(false);
            setEmailStatusFlag(result.flag);
            setLoginMessage(""); // 不直接显示在表单下方
            break;
          default:
            setIsExist(false);
            setShowFirstTimeUser(true);
            setEmailStatusFlag("");
            setLoginMessage("");
        }
      } else {
        setIsExist(false);
        setShowFirstTimeUser(true);
        setEmailStatusFlag("");
        setLoginMessage("");
      }
    } catch (err) {
      setIsExist(false);
      setShowFirstTimeUser(true);
      setEmailStatusFlag("");
      setLoginMessage("Network error, please try again.");
    }
  };

  const fetchLoginBackground = async () => {
    try {
      const result = await ApiService.getLoginBackground();
      if (result.status === 200) {
        setLoginBackground(result.data.login_background || bgImg);
      } else {
        setLoginBackground(bgImg); // Fallback to default background if API fails
      }
    } catch (err) {
      console.error("Failed to fetch login background:", err);
      setLoginBackground(bgImg); // Fallback to default background if API fails
    }
  };

  const handleBack = () => {
    setIsExist(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await ApiService.login({
        company_email: email,
        username,
        password,
      });

      if (data && data.data?.access_token) {
        // Clear everything before storing fresh data except hidePromoMemo keys
        Object.keys(localStorage)
          .filter(key => !key.startsWith("hidePromoMemo"))
          .forEach(key => localStorage.removeItem(key));

        localStorage.setItem("access_token", data.data.access_token);
        // save session_key if backend returns one (SSO)
        if (data.data.session_key) {
          localStorage.setItem("sso_session_key", data.data.session_key);
        }
        // save salesman_id if returned
        const sid = data.data.salesman_id ?? data.data.salesman_ID;
        localStorage.setItem("salesman_id", sid);
        dispatch(
          login({
            user: {
              name: data.data.user_name,
              email: data.data.user_email,
              profile_photo_url: data.data.profile_photo_url,
              is_subuser: data.data.is_subuser || false,
              subuser_id: data.data.subuser_id || "",
              sub_branch: data.data.sub_branch || null,
              main_id: data.data.main_id || null,
              salesman_id: data.data.salesman_id || null,
              company_name: data.data.company_name || "",
              has_cbd: data.data.has_cbd || false,
              has_term: data.data.has_term || false,
            },
            sub_role: data.data.sub_role || [],
          }),
        );
        // navigate("/", { replace: true }); //after login, the login page is replaced in history, so clicking back will not return to it.
      } else {
        setLoginMessage("Login failed. Please check your credentials.");
      }
    } catch (err) {
      setLoginMessage("Login failed. Please try again.");
    }
  };

  useEffect(() => {
    fetchLoginBackground();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="login"
      style={{
        backgroundImage: `url(${loginBackground})`,
        backgroundSize: "contain",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="login-content">
        <div className="contentleft">
          {/* <div className="qrcode-title">
            <strong>Scan QR to login</strong>
          </div>
          <div className="qrcode">
            <FallbackImg src={QRcode} alt="qrcode" />
          </div>
          <div className="qrcode-description">
            Open <a href="/unityapp">Unity app</a> to scan
            <br />
            How to scan?
          </div>

          <div className="or">or</div> */}
        </div>

        <div className="contentright-container">
          <div className="contentright-bg"></div>
          <div className="contentright">
            {!isExist ? (
              <>
                {/* Authenticate */}
                <div className="authen-title">
                  <strong>Login / Register Account</strong>
                </div>

                <form
                  onSubmit={handleCompanyEmail}
                  className="authen-input-container"
                >
                  <div className="authen-input">
                    Please enter company email to continue
                    <div className="input-container">
                      <input
                        id="signin-email"
                        type="email"
                        placeholder="Company Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <button type="button" onClick={handleCompanyEmail}>
                      CONTINUE
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <>
                {/* Login */}
                <form onSubmit={handleLogin} className="login-input-container">
                  <div className="back-button">
                    <button type="button" onClick={handleBack}>
                      <FallbackImg
                        src={ArrowRight}
                        alt="arrowright"
                        width="18"
                        height="18"
                      />
                      <strong>Back</strong>
                    </button>
                  </div>
                  <div className="login-title">
                    <strong>Welcome Back!</strong>
                  </div>

                  <div className="login-input">
                    <div className="input-container">
                      <input
                        id="username"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </div>
                    <div className="input-container">
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <div className="password-icon">
                        <FallbackImg
                          src={showPassword ? eyeActive : eyeInactive}
                          alt={showPassword ? "show password" : "hide password"}
                          style={{ height: 15, width: 20, cursor: "pointer" }}
                          onClick={() => setShowPassword((prev) => !prev)}
                        />
                      </div>
                    </div>

                    <div className="forgetpass-button">
                      <Link to="/forgetpass">Forgot Password?</Link>
                    </div>

                    <button type="submit">LOGIN</button>
                    {loginMessage && (
                      <div className="login-message">{loginMessage}</div>
                    )}
                  </div>
                </form>
              </>
            )}
          </div>
          {showFirsTimeUser && (
            //  <MultiPurpose
            //   title="First Time User"
            //   message="Your company email does not exist, do you want to register an account?"
            //   yesText="YES"
            //   noText="NO"
            //   showYesLink={true}
            //   yesLink="/register"
            //   onNo={() => setShowFirstTimeUser(false)}
            //   onClose={() => setShowFirstTimeUser(false)}
            // />
            <MultiPurpose
              title="First Time User"
              message="Your company email does not exist, do you want to register an account?"
              yesText="YES"
              noText="NO"
              showYesLink={false}
              onYes={() => {
                setShowFirstTimeUser(false);
                setShowNotAvailablePopup(true);
              }}
              onNo={() => setShowFirstTimeUser(false)}
              onClose={() => setShowFirstTimeUser(false)}
            />
          )}
          {emailStatusFlag === "inactive" && (
            <MultiPurpose
              title="Account Inactive"
              message="Your account is inactive. Please contact support."
              yesText="OK"
              onYes={() => setEmailStatusFlag("")}
              onClose={() => setEmailStatusFlag("")}
              hideNo={true}
            />
          )}
          {emailStatusFlag === "need_verify" && (
            <MultiPurpose
              title="Email Verification Needed"
              message="Your account needs email verification. Please check your email."
              yesText="OK"
              onYes={() => setEmailStatusFlag("")}
              onClose={() => setEmailStatusFlag("")}
              hideNo={true}
            />
          )}
          {emailStatusFlag === "approving" && (
            <MultiPurpose
              title="Account Under Review"
              message="Your account is under review. Please wait for approval."
              yesText="OK"
              onYes={() => setEmailStatusFlag("")}
              onClose={() => setEmailStatusFlag("")}
              hideNo={true}
            />
          )}
          {showNotAvailablePopup && (
            <MultiPurpose
              title="Not Available"
              message="This feature is not available now."
              yesText="OK"
              onYes={() => setShowNotAvailablePopup(false)}
              onClose={() => setShowNotAvailablePopup(false)}
              hideNo={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
